import React from 'react'
import { NavLink } from 'react-router-dom'

const Program = () => {
    return (
        <div className="row wrapper__wrap-info">
            <div className="items col-md-4">
                <img src="./../images/fitness-biceps.png" className="mb-4" alt="" />
                <h5 className="medium font__size--18 text__20-1024">1.Fill in your information.</h5>
                <p className="normal font__size--16 text__16-1024 color__gray-2 mb-4">Clients complete a form detailing their medical history, injuries, and food preferences to help us understand their needs.</p>

                <NavLink
                  to="/programs/detail" className="d-inline-block color__black">
                    <div className="d-flex align-items-center">
                    </div>
                </NavLink>
            </div>
            <div className="items bg__purple col-md-4">
                <img src="./../images/fitness-biceps.png" className="mb-4" alt="" />
                <h5 className="medium font__size--18 text__20-1024 color__white">2.Receive personalized plan </h5>
                <p className="medium font__size--16 text__16-1024 color__gray-1 mb-4">Once we get your data, we'll create a program for you in 2 to 5 days.</p>

                <NavLink
                  to="/programs/detail" className="d-inline-block color__black">
                    <div className="d-flex align-items-center">
                    </div>
                </NavLink>
            </div>
            <div className="items col-md-4">
                <img src="./../images/fitness-biceps.png" className="mb-4" alt="" />
                <h5 className="medium font__size--18 text__20-1024">3.See the change by yourself!</h5>
                <p className="normal font__size--16 text__16-1024 color__gray-2 mb-4">Follow our plan, and you'll be amazed at the quick changes in your body shape, energy, health, and confidence.</p>

                <NavLink
                  to="/programs/detail" className="d-inline-block color__black text__16-1024">
                    <div className="d-flex align-items-center">
                    </div>
                </NavLink>
            </div>
        </div>
    )
}

export default Program